module.exports = __webpack_public_path__ + "static/media/Inter-Medium-slnt=0.ddc03dcd.ttf";